<script setup>
import ActionAgentItem from './ActionAgentItem.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

defineOptions({
  name: 'ActionTabItem'
});

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  isEnoughAttrs: {
    type: Boolean,
    default: () => false
  }
});

const listAction = computed(() => {
  const cmds = ['install', 'start', 'stop', 'delete', 'update'];
  return cmds.map((item) => ({
    actionName: t(`button.${item}`),
    url: props.data[`${item}Cmd`],
    isEnoughAttrs: props.isEnoughAttrs
  }));
});
</script>

<template>
  <div class="agent-tab">
    <ActionAgentItem v-for="(item, idx) in listAction" :key="idx" :="item" />
  </div>
</template>

<style scoped lang="scss"></style>
